export const USER_TYPE = {
  patient: 'patientProfile',
  doctor: 'doctorProfile',
  user: 'userProfile',
  userOnboarding: 'userOnboarding',
};

export const USER_ROLE = {
  owner: 'platform_owner',
  doctor: 'independent_doctor',
  virtualClinicDoctor: 'virtual_clinic_doctor',
  virtualClinicAdmin: 'virtual_clinic_admin',
};

export const USER_PROFILE_STATUSES = {
  invited: 'invited',
  active: 'active',
  inactive: 'inactive',
  pending: 'pending',
};
